module.exports = __webpack_public_path__ + "media/images/category_icons/video-53735bdfd330a4b62f749781d1ad48fc.svg";